import { ReactNode, CSSProperties } from 'react'

interface H1Props extends React.HTMLAttributes<HTMLHeadingElement> {
	cssVars?: Record<string, string>
	children: ReactNode
	className?: string
}

export const H1: React.FC<H1Props> = ({
	cssVars = {},
	children,
	className = '',
	style,
	...props
}) => {
	const inlineStyles: CSSProperties = {
		fontSize: cssVars['fontSize'] || undefined,
		fontWeight: cssVars['fontWeight'] || undefined,
		lineHeight: cssVars['lineHeight'] || undefined,
		fontFamily: cssVars['fontFamily'] || undefined,
		marginBottom: cssVars['marginBottom'] || undefined,
	}

	const mergedStyle = { ...inlineStyles, ...(style || {}) }
	const baseClasses = 'text-4xl font-semibold leading-6 mb-1'
	const composedClassName = [baseClasses, className].filter(Boolean).join(' ')

	return (
		<h1 style={mergedStyle} className={composedClassName} {...props}>
			{children}
		</h1>
	)
}
